import { render, staticRenderFns } from "./CardDatesLegend.vue?vue&type=template&id=0e6c0cb4&scoped=true"
import script from "./CardDatesLegend.vue?vue&type=script&lang=js"
export * from "./CardDatesLegend.vue?vue&type=script&lang=js"
import style0 from "./CardDatesLegend.vue?vue&type=style&index=0&id=0e6c0cb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6c0cb4",
  null
  
)

export default component.exports